import LocationGroupApi from '@/api/LocationGroupApi/LocationGroupApi'

export class LocationGroupModel {
  constructor(data) {
    const {
      id,
      name,
      status,
      published,
      accessibleType,
      locationType,
      locationCount,
      activeLocationCount,
    } = data
    this.id = id
    this.name = name
    this.status = status
    this.published = published
    this.accessibleType = accessibleType
    this.locationType = locationType
    this.locationCount = locationCount
    this.activeLocationCount = activeLocationCount
  }

  get isActive() {
    return this.status === 'active'
  }
}

const assignModel = item => new LocationGroupModel(item)

export class LocationGroupRepository {
  static async getList(
    ownerProfileId,
    locationGroupType,
    withoutEmpty = false,
  ) {
    const result = await LocationGroupApi.fetchLocationGroupList(
      ownerProfileId,
      locationGroupType,
      withoutEmpty,
    )
    return result.items.map(assignModel)
  }
  static async addLocationGroup(
    ownerProfileId,
    locationType,
    name,
    accessibleType,
  ) {
    const result = await LocationGroupApi.addLocationGroup({
      ownerProfileId,
      locationType,
      name,
      accessibleType,
    })
    return result.item
  }
  static async deleteLocationGroup(id) {
    await LocationGroupApi.deleteLocationGroup(id)
  }
}
